import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonProductsModule } from '../../products/common/products-common.module';
import { PageTitleComponent } from '../../ui/controls/page-title/page-title.component';

import { HistorySectionComponent } from './history-section.component';

@NgModule({
	imports: [
		CommonModule,
		CommonProductsModule,
		PageTitleComponent,
	],
	declarations: [HistorySectionComponent],
	exports: [HistorySectionComponent],
})
export class HistorySectionModule { }
